export const publicLinks = [
  { href: '/percorsi', label: 'Percorsi', position: 2 },
  { href: '/catalogo', label: 'Catalogo', position: 3 },
  { href: '/insegnanti', label: 'Insegnanti', position: 4 },
  { href: '/aiuto', label: 'Aiuto', position: 7 },
];

export const privateLinks = [
  { href: '/my-home', label: 'Home', position: 1 },
  { href: 'https://community.vibly.tv/', label: 'Community', position: 5 },
  // { href: '/community', label: 'Community', position: 5 },
];

export const unsubscribedLinks = [{ href: '/abbonati', label: 'Abbonati', position: 6 }];

export const headerLinks = (isAuthenticated: boolean, isSubscribed?: boolean) => {
  const shouldShowSubscriberLinks = isSubscribed && isAuthenticated ? [] : unsubscribedLinks;
  const shouldShowPrivateLinks = isAuthenticated
    ? [...privateLinks, ...publicLinks]
    : [...publicLinks];

  return [...shouldShowPrivateLinks, ...shouldShowSubscriberLinks].sort(
    (a, b) => a.position - b.position,
  );
};
